import { render, staticRenderFns } from "./Networks.vue?vue&type=template&id=056163b6&scoped=true"
import script from "./Networks.vue?vue&type=script&lang=js"
export * from "./Networks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056163b6",
  null
  
)

export default component.exports